var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74984 17.5832L17.0832 9.24984C17.4726 8.86823 17.7824 8.41322 17.9949 7.91111C18.2074 7.40899 18.3182 6.86975 18.3209 6.32454C18.3237 5.77934 18.2183 5.239 18.0109 4.73477C17.8036 4.23054 17.4983 3.77242 17.1128 3.3869C16.7273 3.00137 16.2691 2.6961 15.7649 2.48873C15.2607 2.28136 14.7203 2.17601 14.1751 2.17876C13.6299 2.18152 13.0907 2.29232 12.5886 2.50478C12.0865 2.71723 11.6314 3.02711 11.2498 3.41651L2.91651 11.7498C2.52711 12.1314 2.21723 12.5865 2.00478 13.0886C1.79232 13.5907 1.68152 14.1299 1.67876 14.6751C1.67601 15.2203 1.78136 15.7607 1.98873 16.2649C2.1961 16.7691 2.50137 17.2273 2.8869 17.6128C3.27242 17.9983 3.73054 18.3036 4.23477 18.5109C4.739 18.7183 5.27934 18.8237 5.82454 18.8209C6.36975 18.8182 6.90899 18.7074 7.41111 18.4949C7.91322 18.2824 8.36823 17.9726 8.74984 17.5832Z",
    stroke: "#1C64F2",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0835 7.5835L12.9168 13.4168",
    stroke: "#1C64F2",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.8acc948873015bfde3ff8b0065dbf62c.svg";
export { ForwardRef as ReactComponent };